import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, Input, OnDestroy, QueryList, ViewChildren } from '@angular/core';
import { TableroInformativo } from '../../interfaces/tablero.interface';

@Component({
  selector: 'app-tablero-informativo-two',
  templateUrl: './tablero-informativo-two.component.html',
  styleUrl: './tablero-informativo-two.component.scss'
})
export class TableroInformativoTwoComponent implements AfterViewInit, OnDestroy {
  @ViewChildren('rowBoard', { read: ElementRef }) rowBoard!: QueryList<ElementRef>;
  private _dataIndicators: TableroInformativo[][] = [];
  private resizeObserver!: ResizeObserver;

  @Input()
  set dataIndicators(value: TableroInformativo[][]) {
    this._dataIndicators = value;
    if (this.rowBoard && this.rowBoard.length > 0) {
      this.cdr.detectChanges();
      setTimeout(() => this.updateLastRowLayout(), 0);
    }
  }

  get dataIndicators(): TableroInformativo[][] {
    return this._dataIndicators;
  }

  constructor(private cdr: ChangeDetectorRef) {}

  ngAfterViewInit(): void {
    this.initializeResizeObserver();
  }

  private initializeResizeObserver(): void {
    const lastRow = this.rowBoard.last.nativeElement;

    this.resizeObserver = new ResizeObserver(entries => {
      if (entries[0].target === lastRow) {
        this.updateLastRowLayout();
      }
    });

    this.resizeObserver.observe(lastRow);
  }

  private updateLastRowLayout(): void {
    const lastRow = this.rowBoard.last.nativeElement;
    const parentWidth = (lastRow.parentNode as HTMLElement).clientWidth
    const children = [...lastRow.children];

    children.forEach(col => col.classList.remove('last-row'));

    let totalWidth = 0;
    let current: HTMLElement | null = children.at(-1);

    while (current) {
      const width = Math.trunc(current.getBoundingClientRect().width);
      totalWidth += width;

      if (totalWidth > parentWidth) break;

      current.classList.add('last-row')
      current = current.previousElementSibling as HTMLElement;
    }
  }

  ngOnDestroy() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  }

  formatNumber(value: number): string {
    if (value == null) return '';

    const hasDecimals = value % 1 !== 0;
    const format = hasDecimals ? '1.0-2' : '1.0-0';
    return new Intl.NumberFormat('es-CO', {
      minimumFractionDigits: hasDecimals ? 2 : 0,
      maximumFractionDigits: 2,
    }).format(value);
  }
}
